var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEqual } from 'lodash';
import PopperJS from 'popper.js';
import React from 'react';
var INITIAL_STATE = {
    outOfBoundaries: false,
    placement: null,
    style: {
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0,
        pointerEvents: 'none',
    },
};
function getCurrentValue(value, newValue) {
    return isEqual(value, newValue) ? value : newValue;
}
function updateState(newState) {
    return function (state) {
        return {
            // Preserve the references if the objects are deeply equal.
            style: getCurrentValue(state.style, newState.styles),
            outOfBoundaries: newState.hide,
            placement: newState.placement,
        };
    };
}
var DEFAULT_MODIFIERS = {};
export var usePopper = function (referenceRef, popperRef, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.disabled, disabled = _c === void 0 ? false : _c, _d = _b.placement, placement = _d === void 0 ? 'bottom' : _d, _e = _b.modifiers, modifiers = _e === void 0 ? DEFAULT_MODIFIERS : _e, _f = _b.eventsEnabled, eventsEnabled = _f === void 0 ? true : _f, _g = _b.positionFixed, positionFixed = _g === void 0 ? false : _g;
    var popperJSRef = React.useRef(null);
    var _h = React.useState(INITIAL_STATE), state = _h[0], setState = _h[1];
    React.useEffect(function () {
        if (!disabled &&
            referenceRef.current != null &&
            popperRef.current != null) {
            popperJSRef.current = new PopperJS(referenceRef.current, popperRef.current, {
                placement: placement,
                eventsEnabled: eventsEnabled,
                positionFixed: positionFixed,
                modifiers: __assign(__assign({}, modifiers), { applyStyle: {
                        // We apply the styles ourselves.
                        enabled: false,
                    }, updateStateModifier: {
                        enabled: true,
                        // The same as `applyStyle`.
                        // https://popper.js.org/popper-documentation.html#modifiers..applyStyle.order
                        order: 900,
                        fn: function (data) {
                            // The popper element might have lost his parent during the
                            // computation of the position.
                            // It can be due to a fast removal of the popper.
                            // In case it happenned we don't dispatch the computed state.
                            if (data.instance.popper.parentElement != null) {
                                setState(updateState(data));
                            }
                            return data;
                        },
                    } }),
            });
        }
        return function () {
            setState(INITIAL_STATE);
            popperJSRef.current.destroy();
            popperJSRef.current = null;
        };
    }, 
    // 'popperRef', and 'referenceRef' are React Ref objects.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled, placement, modifiers, eventsEnabled, positionFixed]);
    var scheduleUpdate = React.useCallback(function () {
        if (popperJSRef.current != null) {
            popperJSRef.current.scheduleUpdate();
        }
    }, []);
    return __assign(__assign({}, state), { scheduleUpdate: scheduleUpdate });
};
usePopper.PLACEMENTS = PopperJS.placements;
